





































import { Vue, Component, Prop } from 'vue-property-decorator';

import RateSelector from '~/components/partials/RateSelector.vue';

@Component({
  components: { RateSelector },
})
export default class RatingKpis extends Vue {
  @Prop(Number) averageRatesNote: 0;
  @Prop(Array) ratings: [];

  /*
    This method will apply style inside template to fill a line with color, based
    on amount of ratings to a given note
  */
  widthRate (i: any) {
    const occurence: number = this.ratings.filter((c: any) => c.note === i).length;

    if (occurence === -1 || occurence === 0) return 'width: 0%';

    const percentage = (occurence * 100) / this.ratings.length;
    return `width: ${percentage}%`;
  }
}
